<style src="./EditMaxItem.scss" lang="scss" scoped></style>
<template>
  <section class="edit-max-item">
    <div class="item-max selected">
      <span v-if="maxSelected">Esse produto ainda não tem um preço máximo definido</span>
      <div class="max-search">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EditMaxItem',
  components: {
    // FormFileInput
  },
  data () {
    return {
      maxSelected: false
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/components/edit-max-item/EditMaxItem.vue